import(/* webpackMode: "eager" */ "/runner/_work/capital-frontend/capital-frontend/flash-credit/src/app/layout.tsx")